import { createAsyncThunk } from "@reduxjs/toolkit";
import * as lessonProgressService from "../../../api/services/lessonProgress";

// Get all lessons for a course with user progress
export const loadCourseLessons = createAsyncThunk(
  "lessonProgress/loadCourseLessons",
  async (courseId, { rejectWithValue }) => {
    try {
      const response = await lessonProgressService.getCourseLessons(courseId);
      return response;
    } catch (error) {
      if (error.expired) {
        return rejectWithValue({
          message: error.message,
          expired: true,
          expiryDate: error.expiryDate,
        });
      }
      if (error.accessDenied) {
        return rejectWithValue({
          message: error.message,
          accessDenied: true,
        });
      }
      return rejectWithValue(error.message);
    }
  },
);

// Get specific lesson with progress
export const loadLesson = createAsyncThunk(
  "lessonProgress/loadLesson",
  async (lessonId, { rejectWithValue }) => {
    try {
      const response = await lessonProgressService.getLesson(lessonId);
      return response;
    } catch (error) {
      if (error.expired) {
        return rejectWithValue({
          message: error.message,
          expired: true,
          expiryDate: error.expiryDate,
        });
      }
      if (error.accessDenied) {
        return rejectWithValue({
          message: error.message,
          accessDenied: true,
        });
      }
      return rejectWithValue(error.message);
    }
  },
);

// Update lesson progress
export const updateLessonProgress = createAsyncThunk(
  "lessonProgress/updateProgress",
  async ({ lessonId, progressData }, { rejectWithValue }) => {
    try {
      const response = await lessonProgressService.updateProgress(
        lessonId,
        progressData,
      );
      return { lessonId, ...response };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Check certificate eligibility
export const checkCertificateEligibility = createAsyncThunk(
  "lessonProgress/checkCertificateEligibility",
  async (courseId, { rejectWithValue }) => {
    try {
      const response =
        await lessonProgressService.checkCertificateEligibility(courseId);
      return { courseId, ...response };
    } catch (error) {
      if (error.expired || error.accessDenied) {
        return rejectWithValue({
          message: error.message,
          expired: !!error.expired,
          accessDenied: !!error.accessDenied,
          expiryDate: error.expiryDate,
        });
      }
      return rejectWithValue(error.message);
    }
  },
);

// Complete lesson (mark as 100% finished)
export const completeLesson = createAsyncThunk(
  "lessonProgress/completeLesson",
  async ({ lessonId, currentTime, duration }, { rejectWithValue }) => {
    try {
      const response = await lessonProgressService.updateProgress(lessonId, {
        currentTime,
        duration,
        forceComplete: true,
      });
      return { lessonId, ...response };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
